<template>
  <div>
    <div>
      <div style="margin-top: 20px">
        <strong>{{
          $l("components.settings.licenseInfor", "License information")
        }}</strong>
      </div>

      <div class="columns" style="margin-top: 10px">
        <div class="column is-one-fifth nowrap">
          <span>{{ $l("components.settings.product", "Product") + ":" }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.copyright", "Copyright") + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.serverUpdate", "Server update") + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.licenseCode", "License code") + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.expirationDate", "Expiration date") + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.maxAgent", "Max agent") + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.maxEDRServer", "Max EDR server") + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l(
              "components.settings.maxLevelEDRServer",
              "Max level EDR server"
            ) + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.proxyServer", "Proxy server") + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.serverStatus", "Server status") + ":"
          }}</span>
          <br />
          <br />
          <span>{{
            $l("components.settings.periodTime", "Period time") + ":"
          }}</span>
        </div>

        <div class="column nowrap">
          <span>CyRadar Endpoint Security Server</span>
          <br />
          <br />
          <span>CyRadar.,JSC</span>
          <br />
          <br />
          <span>{{
            copyrightInfo.server
              ? copyrightInfo.server.join(", ")
              : $l("components.settings.empty", "N/A")
          }}</span
          ><span
            @click="showForm('update-server')"
            class="edit"
            v-if="copyrightInfo.server && isAdmin"
            ><svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.0616 1.52827C14.785 1.26792 14.3365 1.26792 14.0599 1.52827L13.442 2.10984C12.6521 1.7547 11.6774 1.88501 11.0232 2.50077L3.51014 9.57184L7.51708 13.3431L15.0301 6.27201C15.6843 5.65625 15.8228 4.73888 15.4455 3.99546L16.0634 3.41389C16.34 3.15354 16.34 2.73143 16.0634 2.47108L15.0616 1.52827ZM12.0385 7.20203L7.51708 11.4575L5.51361 9.57184L10.035 5.31641L12.0385 7.20203ZM13.3264 5.98984L14.0284 5.3292C14.305 5.06885 14.305 4.64674 14.0284 4.38639L13.0266 3.44358C12.75 3.18323 12.3015 3.18323 12.0249 3.44358L11.323 4.10422L13.3264 5.98984Z"
                fill="black"
              />
              <path
                d="M1.41667 15.2998L2.91955 10.1141L6.92621 13.8856L1.41667 15.2998Z"
                fill="black"
              />
            </svg>
          </span>
          <br />
          <br />
          <span>CyRadar, JSC </span>
          <br />
          <br />
          <span
            class="status-column"
            :class="{
              'status-column': dateDistance(copyrightInfo.expiredAt) <= 0,
            }"
            >{{
              copyrightInfo.expiredAt !== "0001-01-01T00:00:00Z"
                ? renderTime(copyrightInfo.expiredAt)
                : $l("components.settings.empty", "N/A")
            }}</span
          >
          <br />
          <br />
          <span>{{
            copyrightInfo.agentLimit === -1
              ? $l("components.settings.unlimit", "Unlimit")
              : copyrightInfo.agentLimit
              ? copyrightInfo.agentLimit
              : $l("components.settings.empty", "N/A")
          }}</span>
          <br />
          <br />
          <span>{{
            copyrightInfo.serverLimit === -1
              ? $l("components.settings.unlimit", "Unlimit")
              : copyrightInfo.serverLimit
              ? copyrightInfo.serverLimit
              : $l("components.settings.empty", "N/A")
          }}</span>

          <br />
          <br />
          <span>{{
            copyrightInfo.treeHeight ? copyrightInfo.treeHeight : 5
          }}</span>

          <br />
          <br />
          <span>{{
            copyrightInfo.proxyServer
              ? copyrightInfo.proxyServer
              : $l("components.settings.empty", "N/A")
          }}</span>
          <span
            class="edit"
            @click="showForm('update-proxy')"
            v-if="copyrightInfo.proxyServer && isAdmin"
            ><svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.0616 1.52827C14.785 1.26792 14.3365 1.26792 14.0599 1.52827L13.442 2.10984C12.6521 1.7547 11.6774 1.88501 11.0232 2.50077L3.51014 9.57184L7.51708 13.3431L15.0301 6.27201C15.6843 5.65625 15.8228 4.73888 15.4455 3.99546L16.0634 3.41389C16.34 3.15354 16.34 2.73143 16.0634 2.47108L15.0616 1.52827ZM12.0385 7.20203L7.51708 11.4575L5.51361 9.57184L10.035 5.31641L12.0385 7.20203ZM13.3264 5.98984L14.0284 5.3292C14.305 5.06885 14.305 4.64674 14.0284 4.38639L13.0266 3.44358C12.75 3.18323 12.3015 3.18323 12.0249 3.44358L11.323 4.10422L13.3264 5.98984Z"
                fill="black"
              />
              <path
                d="M1.41667 15.2998L2.91955 10.1141L6.92621 13.8856L1.41667 15.2998Z"
                fill="black"
              />
            </svg>
          </span>
          <br />
          <br />
          <span
            :class="{
              enabled: copyrightInfo.status,
              inactive: !copyrightInfo.status,
            }"
            >{{
              copyrightInfo.status
                ? $l("components.settings.online", "Online")
                : $l("components.settings.offline", "Offline")
            }}</span
          >
          <br />
          <br />
          <span>{{
            (copyrightInfo.interval ? copyrightInfo.interval : "30") +
            " " +
            (!copyrightInfo.unit
              ? $l("components.settings.minutes", "minutes")
              : copyrightInfo.unit === "minutes"
              ? $l("components.settings.minutes", "minutes")
              : $l("components.settings.hours", "hours"))
          }}</span
          ><span
            class="edit"
            @click="showForm('update-period')"
            v-if="copyrightInfo.interval && copyrightInfo.unit && isAdmin"
            ><svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.0616 1.52827C14.785 1.26792 14.3365 1.26792 14.0599 1.52827L13.442 2.10984C12.6521 1.7547 11.6774 1.88501 11.0232 2.50077L3.51014 9.57184L7.51708 13.3431L15.0301 6.27201C15.6843 5.65625 15.8228 4.73888 15.4455 3.99546L16.0634 3.41389C16.34 3.15354 16.34 2.73143 16.0634 2.47108L15.0616 1.52827ZM12.0385 7.20203L7.51708 11.4575L5.51361 9.57184L10.035 5.31641L12.0385 7.20203ZM13.3264 5.98984L14.0284 5.3292C14.305 5.06885 14.305 4.64674 14.0284 4.38639L13.0266 3.44358C12.75 3.18323 12.3015 3.18323 12.0249 3.44358L11.323 4.10422L13.3264 5.98984Z"
                fill="black"
              />
              <path
                d="M1.41667 15.2998L2.91955 10.1141L6.92621 13.8856L1.41667 15.2998Z"
                fill="black"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>

    <div>
      <div style="margin-top: 20px">
        <strong>{{
          $l("components.settings.updateLicense", "Update license")
        }}</strong>
      </div>

      <div class="columns" style="margin-top: 10px">
        <div class="column is-5 nowrap">
          <span>
            {{
              $l(
                "components.settings.updateLicenseText1",
                "To use another license, please select "
              )
            }}
            <strong>{{
              $l("components.settings.updateLicenseText2", "Change license ")
            }}</strong>
            {{ $l("components.settings.updateLicenseText3", "below.") }} <br />
            {{
              $l(
                "components.settings.updateLicenseText4",
                "In case you do not have a license, please contact hotline (+84) 24 7300 6066 or "
              )
            }}
            <u>{{
              $l(
                "components.settings.updateLicenseText5",
                "contact@cyradar.com."
              )
            }}</u>
          </span>
        </div>
      </div>

      <div class="columns" style="margin-top: 10px">
        <div
          class="column is-one-fifth nowrap"
          style="display: flex; align-items: center"
          v-if="isAdmin"
        >
          <span
            ><svg
              width="22"
              height="20"
              viewBox="0 0 22 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.79166 0H0V2H3.2184L5.9872 14.6776H6V15H19V14.7519L21.1932 5.09095L21.5308 4H5.6552L5.08485 1.38852L4.79166 0ZM18.9869 6H6.092L7.62081 13H17.3978L18.9869 6Z"
                fill="black"
              />
              <path
                d="M9 20C10.1046 20 11 19.1046 11 18C11 16.8954 10.1046 16 9 16C7.89543 16 7 16.8954 7 18C7 19.1046 7.89543 20 9 20Z"
                fill="black"
              />
              <path
                d="M18 18C18 19.1046 17.1046 20 16 20C14.8954 20 14 19.1046 14 18C14 16.8954 14.8954 16 16 16C17.1046 16 18 16.8954 18 18Z"
                fill="black"
              />
            </svg>
          </span>
          <span
            class="copyright-actions"
            style="margin-left: 10px; color: #3384ed; font-size: 12px"
            @click="showForm('update-license-online')"
            >{{
              $l(
                "components.settings.updateLicenseOnline",
                "Update license online"
              )
            }}</span
          >
        </div>

        <div
          class="column is-one-fifth nowrap"
          style="display: flex; align-items: center"
          v-if="isAdmin"
        >
          <span
            ><svg
              width="17"
              height="8"
              viewBox="0 0 17 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 0C1.34315 0 0 1.34315 0 3V5C0 6.65685 1.34315 8 3 8C4.65685 8 6 6.65685 6 5H12V7H14V5H15V7H17V3H6C6 1.34315 4.65685 0 3 0ZM4 5V3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3V5C2 5.55228 2.44772 6 3 6C3.55228 6 4 5.55228 4 5Z"
                fill="black"
              />
            </svg>
          </span>
          <span
            class="copyright-actions"
            style="margin-left: 10px; color: #3384ed; font-size: 12px"
            @click="showForm('update-license-offline')"
            >{{
              $l(
                "components.settings.updateLicenseOffline",
                "Update license offline"
              )
            }}</span
          >
        </div>

        <div
          class="column is-one-fifth nowrap"
          style="display: flex; align-items: center"
          v-if="isAdmin"
        >
          <span
            ><svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10 18V10H18V18H10ZM12 12H16L16 16H12V12Z"
                fill="black"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.54292e-07 8L0 2.54292e-07L8 0V8H2.54292e-07ZM2 2L6 2V6L2 6L2 2Z"
                fill="black"
              />
              <path d="M15 3V9H13V5L9 5V3L15 3Z" fill="black" />
              <path d="M9 15H3L3 9H5L5 13H9V15Z" fill="black" />
            </svg>
          </span>
          <span
            class="copyright-actions"
            style="margin-left: 10px; color: #3384ed; font-size: 12px"
            @click="showForm('check-connection')"
            >{{
              $l("components.settings.checkConnection", "Check connection")
            }}</span
          >
        </div>
      </div>
    </div>
    <modal :show.sync="formModal.formUpdateLicenseOnline.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formUpdateLicenseOnline.isFormOpen = false"
        >
          <i
            ><svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                fill="#666666"
              />
            </svg>
          </i>
        </div>
        <div style="text-align: center">
          <span>{{
            $l(
              "components.settings.updateLicenseOnline",
              "Update license online"
            )
          }}</span>
        </div>
        <div style="margin: auto; width: 80%">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label"
                  >{{ $l("components.settings.licenseCode", "License code") }}
                  <span style="color: red"> *</span>
                </label>
                <div class="control">
                  <input
                    v-model="
                      formModal.formUpdateLicenseOnline.values.licenseCode
                    "
                    type="text"
                    class="input"
                    placeholder="XXXXX-XXXXX-XXXXX-XXXXX-XXXXX"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label"
                  >{{ $l("components.settings.serverUpdate", "Server update") }}
                  <span style="color: red"> *</span>
                </label>
                <div class="control">
                  <input
                    v-model="formModal.formUpdateLicenseOnline.values.server"
                    type="text"
                    class="input"
                    placeholder="https://api.edr.server.com:6767"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label"
                  >{{ $l("components.settings.proxy", "Proxy") }}
                </label>
                <div class="control">
                  <input
                    v-model="formModal.formUpdateLicenseOnline.values.proxy"
                    type="text"
                    class="input"
                    placeholder="https://user:pass@192.189.1.1:6767"
                  />
                </div>
              </div>
            </div>
          </div>

          <div slot="footer" class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button"
                @click.prevent="
                  formModal.formUpdateLicenseOnline.isFormOpen = false
                "
              >
                {{ $l("global.cancel", "Cancel") }}
              </button>
            </div>

            <div class="control">
              <button
                class="button is-info"
                @click.prevent="updateLicenseOnline"
              >
                {{ $l("global.active", "Active") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <!--  -->

    <modal :show.sync="formModal.formUpdateLicenseOffline.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formUpdateLicenseOffline.isFormOpen = false"
        >
          <i
            ><svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                fill="#666666"
              />
            </svg>
          </i>
        </div>
        <div style="text-align: center">
          <span>{{
            $l(
              "components.settings.updateLicenseOffline",
              "Update license offline"
            )
          }}</span>
        </div>
        <div style="margin: auto; width: 80%">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label"
                  >{{ $l("components.settings.licenseCode", "License code") }}
                  <span style="color: red"> *</span>
                </label>
                <div class="control">
                  <input
                    v-model="
                      formModal.formUpdateLicenseOffline.values.licenseCode
                    "
                    type="text"
                    class="input"
                    placeholder="XXXXX-XXXXX-XXXXX-XXXXX-XXXXX"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label"
                  >{{ $l("components.settings.licenseInfor", "License infor") }}
                  <span style="color: red"> *</span>
                </label>
                <div class="control">
                  <Input
                    v-model="
                      formModal.formUpdateLicenseOffline.values.licenseInfor
                    "
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 15 }"
                    placeholder="TkRjNE9UazRPVFUzTkRjNE1UZ3pOakkyTXprd056WTRPRGd4TlRVNU5qVTJNell6T0Rrd016WTBOakV5TURnMU5qQTVNelF3TXpVeU1UVXhPRFV4TkRBNU1EVTJNakF4TlRjMU16ZzFORFEwTkRFNE5UWTJNRGMwTVRBNU5qYzRORFEwTURnek56SXpNamd4TURNMk56WTFNemN6TWpjd05EY3dOak13TkRrM09ERXdPRGMwT1RBeU9UUTVNVEEwT0Rnek5qTXhPRFU0TkRVd01EUXlPVE01TXpnd056a3dORGN3TlRReE5UazROekUxT0RNeE1UYzFOams1T0RnM"
                  />
                </div>
              </div>
            </div>
          </div>

          <div slot="footer" class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button"
                @click.prevent="
                  formModal.formUpdateLicenseOffline.isFormOpen = false
                "
              >
                {{ $l("global.cancel", "Cancel") }}
              </button>
            </div>

            <div class="control">
              <button
                class="button is-info"
                @click.prevent="updateLicenseOffline"
              >
                {{ $l("global.active", "Active") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formCheckConnection.isFormOpen">
      <box>
        <div style="margin: auto; width: 80%">
          <div
            class="close-icon"
            @click="formModal.formCheckConnection.isFormOpen = false"
          >
            <i
              ><svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                  fill="#666666"
                />
              </svg>
            </i>
          </div>
          <div style="text-align: center">
            <span>{{
              $l("components.settings.checkConnection", "Check connection")
            }}</span>
          </div>

          <div style="margin-top: 35px; margin-bottom: 35px">
            <span>{{
              $l(
                "components.settings.checkConnectionToServerUpdate",
                "Check connection to server update"
              )
            }}</span>
          </div>

          <div slot="footer" class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button"
                @click.prevent="
                  formModal.formCheckConnection.isFormOpen = false
                "
              >
                {{ $l("global.cancel", "Cancel") }}
              </button>
            </div>

            <div class="control">
              <button class="button is-info" @click.prevent="checkConnection">
                {{ $l("global.check", "Check") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formUpdateServer.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formUpdateServer.isFormOpen = false"
        >
          <i
            ><svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                fill="#666666"
              />
            </svg>
          </i>
        </div>
        <div style="text-align: center">
          <span>{{
            $l("components.settings.updateServer", "Update server")
          }}</span>
        </div>
        <div style="margin: auto; width: 80%">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label"
                  >{{ $l("components.settings.serverUpdate", "Server update") }}
                </label>
                <div class="control">
                  <input
                    v-model="formModal.formUpdateServer.values.server"
                    type="text"
                    class="input"
                    placeholder="https://api.edr.server.com:6767"
                  />
                </div>
              </div>
            </div>
          </div>

          <div slot="footer" class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button"
                @click.prevent="formModal.formUpdateServer.isFormOpen = false"
              >
                {{ $l("global.cancel", "Cancel") }}
              </button>
            </div>

            <div class="control">
              <button class="button is-info" @click.prevent="updateServer">
                {{ $l("global.update", "Update") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formUpdateProxy.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formUpdateProxy.isFormOpen = false"
        >
          <i
            ><svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                fill="#666666"
              />
            </svg>
          </i>
        </div>
        <div style="text-align: center">
          <span>{{
            $l("components.settings.updateProxy", "Update proxy")
          }}</span>
        </div>
        <div style="margin: auto; width: 80%">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label"
                  >{{ $l("components.settings.proxyServer", "Proxy serer") }}
                </label>
                <div class="control">
                  <input
                    v-model="formModal.formUpdateProxy.values.proxy"
                    type="text"
                    class="input"
                    placeholder="https://api.edr.server.com:6767"
                  />
                </div>
              </div>
            </div>
          </div>

          <div slot="footer" class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button"
                @click.prevent="formModal.formUpdateProxy.isFormOpen = false"
              >
                {{ $l("global.cancel", "Cancel") }}
              </button>
            </div>

            <div class="control">
              <button class="button is-info" @click.prevent="updateProxy">
                {{ $l("global.update", "Update") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formUpdatePeriod.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formUpdatePeriod.isFormOpen = false"
        >
          <i
            ><svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                fill="#666666"
              />
            </svg>
          </i>
        </div>
        <div style="text-align: center">
          <span>{{
            $l("components.settings.updateProxy", "Update proxy")
          }}</span>
        </div>
        <div style="margin: auto; width: 80%">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label"
                  >{{ $l("components.settings.updatePeriod", "Update period") }}
                </label>
                <div
                  class="control"
                  :class="{ disabled: !formModal.formUpdatePeriod.values.unit }"
                >
                  <v-select
                    v-model="formModal.formUpdatePeriod.values.interval"
                    :clearable="false"
                    :options="
                      formModal.formUpdatePeriod.values.unit === 'minutes'
                        ? listIntervalMinutes
                        : listIntervalHours
                    "
                  >
                  </v-select>
                </div>
              </div>
            </div>

            <div class="column" style="margin-top: 28px">
              <div class="field">
                <div class="control">
                  <v-select
                    v-model="formModal.formUpdatePeriod.values.unit"
                    :clearable="false"
                    :reduce="(option) => option.value"
                    :options="[
                      {
                        label: $l('components.settings.minutes', 'minutes'),
                        value: 'minutes',
                      },

                      {
                        label: $l('components.settings.hours', 'hours'),
                        value: 'hours',
                      },
                    ]"
                  >
                  </v-select>
                </div>
              </div>
            </div>
          </div>

          <div
            slot="footer"
            class="field is-grouped is-grouped-right"
            style="margin-top: 100px"
          >
            <div class="control">
              <button
                class="button"
                @click.prevent="formModal.formUpdatePeriod.isFormOpen = false"
              >
                {{ $l("global.cancel", "Cancel") }}
              </button>
            </div>

            <div class="control">
              <button class="button is-info" @click.prevent="updatePeriod">
                {{ $l("global.update", "Update") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formResultUpdateLicenseOnline.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formResultUpdateLicenseOnline.isFormOpen = false"
        >
          <i
            ><svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                fill="#666666"
              />
            </svg>
          </i>
        </div>
        <div style="text-align: center">
          <span>{{
            $l(
              "components.settings.updateLicenseOnline",
              "Update license online"
            )
          }}</span>
        </div>
        <div style="margin: auto; width: 80%">
          <div class="columns" style="margin-top: 10px">
            <div class="column is-5 nowrap">
              <span>{{ $l("components.settings.check", "Check") + ":" }}</span>
              <br />
              <br />
              <span>{{
                $l("components.settings.licenseCode", "License code") + ":"
              }}</span>

              <br />
              <br />
              <span
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
                >{{
                  $l("components.settings.expirationDate", "Expiration date") +
                  ":"
                }}</span
              >
              <br
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
              />
              <br
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
              />
              <span
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
                >{{
                  $l("components.settings.maxAgent", "Max agent") + ":"
                }}</span
              >
              <br
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
              />
              <br
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
              />
              <span
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
                >{{
                  $l("components.settings.maxEDRServer", "Max EDR serve") + ":"
                }}</span
              >

              <span
                v-if="!formModal.formResultUpdateLicenseOnline.values.status"
                >{{
                  $l("components.settings.information", "Information") + ":"
                }}</span
              >
            </div>

            <div class="column nowrap">
              <span
                :class="{
                  enabled:
                    formModal.formResultUpdateLicenseOnline.values.status,
                  inactive:
                    !formModal.formResultUpdateLicenseOnline.values.status,
                }"
                >{{
                  formModal.formResultUpdateLicenseOnline.values.status
                    ? $l("components.settings.success", "Success")
                    : $l("components.settings.fail", "Fail")
                }}</span
              >
              <br />
              <br />
              <span>{{
                formModal.formResultUpdateLicenseOnline.values.licenseCode
              }}</span>

              <br />
              <br />
              <span
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
                >{{
                  formModal.formResultUpdateLicenseOnline.values.expiredAt
                }}</span
              >
              <br
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
              />
              <br
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
              />
              <span
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
                >{{
                  formModal.formResultUpdateLicenseOnline.values.agentLimit
                }}</span
              >
              <br
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
              />
              <br
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
              />
              <span
                v-if="formModal.formResultUpdateLicenseOnline.values.status"
                >{{
                  formModal.formResultUpdateLicenseOnline.values.serverLimit
                }}</span
              >

              <span
                v-if="!formModal.formResultUpdateLicenseOnline.values.status"
                >{{
                  formModal.formResultUpdateLicenseOnline.values.result
                }}</span
              >
            </div>
          </div>

          <div slot="footer" class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button"
                @click.prevent="
                  formModal.formResultUpdateLicenseOnline.isFormOpen = false
                "
              >
                {{ $l("global.close", "Close") }}
              </button>
            </div>

            <div
              class="control"
              v-if="!formModal.formResultUpdateLicenseOnline.values.status"
            >
              <button
                class="button is-info"
                @click.prevent="
                  formModal.formResultUpdateLicenseOnline.isFormOpen = false;
                  formModal.formUpdateLicenseOnline.isFormOpen = true;
                "
              >
                {{ $l("global.checkAgain", "Check again") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formResultUpdateLicenseOffline.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formResultUpdateLicenseOffline.isFormOpen = false"
        >
          <i
            ><svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                fill="#666666"
              />
            </svg>
          </i>
        </div>
        <div style="text-align: center">
          <span>{{
            $l(
              "components.settings.updateLicenseOffline",
              "Update license offline"
            )
          }}</span>
        </div>
        <div style="margin: auto; width: 80%">
          <div class="columns" style="margin-top: 10px">
            <div class="column is-5 nowrap">
              <span>{{ $l("components.settings.check", "Check") + ":" }}</span>
              <br />
              <br />
              <span>{{
                $l("components.settings.licenseCode", "License code") + ":"
              }}</span>

              <br />
              <br />
              <span
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
                >{{
                  $l("components.settings.expirationDate", "Expiration date") +
                  ":"
                }}</span
              >
              <br
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
              />
              <br
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
              />
              <span
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
                >{{
                  $l("components.settings.maxAgent", "Max agent") + ":"
                }}</span
              >
              <br
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
              />
              <br
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
              />
              <span
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
                >{{
                  $l("components.settings.maxEDRServer", "Max EDR serve") + ":"
                }}</span
              >
              <span
                v-if="!formModal.formResultUpdateLicenseOffline.values.status"
                >{{
                  $l("components.settings.information", "Information") + ":"
                }}</span
              >
            </div>

            <div class="column nowrap">
              <span
                :class="{
                  enabled:
                    formModal.formResultUpdateLicenseOffline.values.status,
                  inactive:
                    !formModal.formResultUpdateLicenseOffline.values.status,
                }"
                >{{
                  formModal.formResultUpdateLicenseOffline.values.status
                    ? $l("components.settings.success", "Success")
                    : $l("components.settings.fail", "Fail")
                }}</span
              >
              <br />
              <br />
              <span>{{
                formModal.formResultUpdateLicenseOffline.values.licenseCode
              }}</span>

              <br />
              <br />
              <span
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
                >{{
                  formModal.formResultUpdateLicenseOffline.values.expiredAt
                }}</span
              >
              <br
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
              />
              <br
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
              />
              <span
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
                >{{
                  formModal.formResultUpdateLicenseOffline.values.agentLimit
                }}</span
              >
              <br
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
              />
              <br
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
              />
              <span
                v-if="formModal.formResultUpdateLicenseOffline.values.status"
                >{{
                  formModal.formResultUpdateLicenseOffline.values.serverLimit
                }}</span
              >
              <span
                v-if="!formModal.formResultUpdateLicenseOffline.values.status"
                >{{
                  formModal.formResultUpdateLicenseOffline.values.result
                }}</span
              >
            </div>
          </div>

          <div slot="footer" class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button"
                @click.prevent="
                  formModal.formResultUpdateLicenseOffline.isFormOpen = false
                "
              >
                {{ $l("global.close", "Close") }}
              </button>
            </div>

            <div
              class="control"
              v-if="!formModal.formResultUpdateLicenseOffline.values.status"
            >
              <button
                class="button is-info"
                @click.prevent="
                  formModal.formResultUpdateLicenseOffline.isFormOpen = false;
                  formModal.formUpdateLicenseOffline.isFormOpen = true;
                "
              >
                {{ $l("global.checkAgain", "Check again") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formResultCheckConnection.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formResultCheckConnection.isFormOpen = false"
        >
          <i
            ><svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                fill="#666666"
              />
            </svg>
          </i>
        </div>
        <div style="text-align: center">
          <span>{{
            $l("components.settings.checkConnection", "Check connection")
          }}</span>
        </div>
        <div style="margin: auto; width: 80%">
          <div class="columns" style="margin-top: 10px">
            <div class="column is-5 nowrap">
              <span>{{ $l("components.settings.check", "Check") + ":" }}</span>
            </div>

            <div class="column nowrap">
              <span
                :class="{
                  enabled: formModal.formResultCheckConnection.values.status,
                  inactive: !formModal.formResultCheckConnection.values.status,
                }"
                >{{
                  formModal.formResultCheckConnection.values.status
                    ? $l("components.settings.success", "Success")
                    : $l("components.settings.fail", "Fail")
                }}</span
              >
            </div>
          </div>

          <div slot="footer" class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button"
                @click.prevent="
                  formModal.formResultCheckConnection.isFormOpen = false
                "
              >
                {{ $l("global.close", "Close") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal>
  </div>
</template>

<script>
import SettingsApi from "@/api/Settings";
import vSelect from "vue-select";

import Format from "date-fns/format";
import moment from "moment";

import SvgIcon from "@jamescoyle/vue-icon";
import { mdiCartOutline, mdiKey } from "@mdi/js";
import { DataTable, DataColumn, Modal } from "@cyradar/ui";
import { Input } from "iview";
import { mapGetters } from "vuex";

export default {
  components: {
    vSelect,
    DataTable,
    DataColumn,
    Modal,
    SvgIcon,
    Input,
  },

  computed: {
    ...mapGetters(["isAdmin"]),
  },

  data() {
    return {
      pathCart: mdiCartOutline,
      pathKey: mdiKey,
      copyrightInfo: {},
      listIntervalMinutes: [],
      listIntervalHours: [],
      formModal: {
        formUpdateLicenseOnline: {
          type: "update-license-online",
          isFormOpen: false,
          values: {
            licenseCode: "",
            server: "",
            proxy: "",
          },
        },

        formUpdateLicenseOffline: {
          type: "update-license-offline",
          isFormOpen: false,
          values: {
            licenseCode: "",
            licenseInfor: "",
          },
        },

        formResultUpdateLicenseOnline: {
          isFormOpen: false,
          values: {
            status: null,
            licenseCode: "",
            expiredAt: "",
            agentLimit: null,
            serverLimit: null,
            result: null,
          },
        },

        formResultUpdateLicenseOffline: {
          isFormOpen: false,
          values: {
            status: null,
            licenseCode: "",
            expiredAt: "",
            agentLimit: null,
            serverLimit: null,
            result: null,
          },
        },

        formCheckConnection: {
          type: "check-connection",
          isFormOpen: false,
        },

        formResultCheckConnection: {
          isFormOpen: false,
          values: {
            status: null,
          },
        },

        formUpdateServer: {
          isFormOpen: false,
          type: "update-server",
          values: {
            server: "",
          },
        },

        formUpdateProxy: {
          isFormOpen: false,
          type: "update-proxy",
          values: {
            proxy: "",
          },
        },

        formUpdatePeriod: {
          isFormOpen: false,
          type: "update-period",
          values: {
            interval: "",
            unit: "",
          },
        },
      },
    };
  },

  methods: {
    dateDistance(date) {
      const now = new Date();
      const endISO = moment(date, moment.ISO_8601);
      const start = moment(now, "HH:mm:ss YYYY-MM-DD");
      const startISO = moment(start.format(), moment.ISO_8601);
      const diff = endISO.diff(startISO, "seconds");
      return diff;
    },

    renderTime(time) {
      return Format(time, "DD/MM/YYYY");
    },

    getCopyright() {
      SettingsApi.getCopyright(this.$http).then((res) => {
        this.copyrightInfo = res;
      });
    },

    updateServer() {
      const sendingForm = {
        interval: this.copyrightInfo.interval,
        unit: this.copyrightInfo.unit,
        proxyServer: this.copyrightInfo.proxyServer,
        servers:
          this.formModal.formUpdateServer.values.server.length > 0
            ? this.formModal.formUpdateServer.values.server.split(",")
            : [],
      };
      this.updateCopyright(sendingForm);
      this.formModal.formUpdateServer.isFormOpen = false;
    },

    updateProxy() {
      const sendingForm = {
        interval: this.copyrightInfo.interval,
        unit: this.copyrightInfo.unit,
        proxyServer: this.formModal.formUpdateProxy.values.proxy,
        servers: this.copyrightInfo.server,
      };
      this.updateCopyright(sendingForm);
      this.formModal.formUpdateProxy.isFormOpen = false;
    },

    updatePeriod() {
      const sendingForm = {
        interval: this.formModal.formUpdatePeriod.values.interval,
        unit: this.formModal.formUpdatePeriod.values.unit,
        proxyServer: this.copyrightInfo.proxyServer,
        servers: this.copyrightInfo.server,
      };
      this.updateCopyright(sendingForm);
      this.formModal.formUpdatePeriod.isFormOpen = false;
    },

    updateCopyright(sendingForm) {
      SettingsApi.updateCopyright(this.$http, sendingForm).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });

        this.getCopyright();
      });
    },

    updateLicenseOnline() {
      const sendingForm = {
        servers: [this.formModal.formUpdateLicenseOnline.values.server],
        proxy: this.formModal.formUpdateLicenseOnline.values.proxy,
        licensecode: this.formModal.formUpdateLicenseOnline.values.licenseCode,
      };
      SettingsApi.updateLicenseOnline(this.$http, sendingForm)
        .then((res) => {
          this.$store.dispatch("NOTIFY", {
            type: "success",
            text: res.message || "",
            duration: 10000,
          });

          this.formModal.formUpdateLicenseOnline.isFormOpen = false;
          this.formModal.formResultUpdateLicenseOnline.isFormOpen = true;

          this.formModal.formResultUpdateLicenseOnline.values = {
            status: 1,
            licenseCode: res.data.fingerprint,
            expiredAt: this.renderTime(res.data.expiredAt)
              ? this.renderTime(res.data.expiredAt)
              : this.$l("components.settings.empty", "N/A"),
            agentLimit: res.data.agentLimit
              ? res.data.agentLimit
              : this.$l("components.settings.empty", "N/A"),
            serverLimit: res.data.serverLimit
              ? res.data.serverLimit
              : this.$l("components.settings.empty", "N/A"),
          };

          this.formModal.formUpdateLicenseOnline.values = {
            licenseCode: "",
            server: "",
            proxy: "",
          };

          this.getCopyright();
        })
        .catch(() => {
          this.formModal.formUpdateLicenseOnline.isFormOpen = false;
          this.formModal.formResultUpdateLicenseOnline.isFormOpen = true;

          this.formModal.formResultUpdateLicenseOnline.values = {
            status: 0,
            licenseCode:
              this.formModal.formUpdateLicenseOnline.values.licenseCode,
            result: this.$l(
              "components.settings.cannotConect",
              "Cannot conect to server"
            ),
          };
        });
    },

    updateLicenseOffline() {
      const licenseInfo = JSON.parse(
        this.formModal.formUpdateLicenseOffline.values.licenseInfor.replace(
          /([\[:])?(\d+)([,\}\]])/g,
          '$1"$2"$3'
        )
      );

      const sendingForm = {
        licenseCode: this.formModal.formUpdateLicenseOffline.values.licenseCode,
        licenseInfo: {
          ...licenseInfo,
        },
      };

      SettingsApi.updateLicenseOffline(this.$http, sendingForm)
        .then((res) => {
          this.$store.dispatch("NOTIFY", {
            type: "success",
            text: res.message,
            duration: 10000,
          });
          this.formModal.formUpdateLicenseOffline.isFormOpen = false;
          this.formModal.formResultUpdateLicenseOffline.isFormOpen = true;
          this.formModal.formResultUpdateLicenseOffline.values = {
            status: 1,
            licenseCode: res.data.fingerprint,
            expiredAt: this.renderTime(res.data.expiredAt)
              ? this.renderTime(res.data.expiredAt)
              : this.$l("components.settings.empty", "N/A"),
            agentLimit: res.data.agentLimit
              ? res.data.agentLimit
              : this.$l("components.settings.empty", "N/A"),
            serverLimit: res.data.serverLimit
              ? res.data.agentLimit
              : this.$l("components.settings.empty", "N/A"),
          };

          this.formModal.formUpdateLicenseOffline.values = {
            licenseCode: "",
            licenseInfor: "",
          };

          this.getCopyright();
        })
        .catch(() => {
          this.formModal.formUpdateLicenseOffline.isFormOpen = false;
          this.formModal.formResultUpdateLicenseOffline.isFormOpen = true;
          this.formModal.formResultUpdateLicenseOffline.values = {
            status: 0,
            licenseCode:
              this.formModal.formUpdateLicenseOffline.values.licenseCode,

            result: this.$l(
              "components.settings.cannotConect",
              "Cannot conect to server"
            ),
          };
        });
    },

    checkConnection() {
      SettingsApi.checkConnection(this.$http)
        .then(() => {
          this.formModal.formCheckConnection.isFormOpen = false;
          this.formModal.formResultCheckConnection.values.status = 1;
          this.formModal.formResultCheckConnection.isFormOpen = true;
        })
        .catch(() => {
          this.formModal.formCheckConnection.isFormOpen = false;
          this.formModal.formResultCheckConnection.values.status = 0;
          this.formModal.formResultCheckConnection.isFormOpen = true;
        });
    },

    showForm(type) {
      if (type === this.formModal.formUpdateLicenseOnline.type) {
        this.formModal.formUpdateLicenseOnline.isFormOpen = true;
      }

      if (type === this.formModal.formUpdateLicenseOffline.type) {
        this.formModal.formUpdateLicenseOffline.isFormOpen = true;
      }

      if (type === this.formModal.formCheckConnection.type) {
        this.formModal.formCheckConnection.isFormOpen = true;
      }

      if (type === this.formModal.formUpdateServer.type) {
        this.formModal.formUpdateServer.values.server =
          this.copyrightInfo.server.join(", ");
        this.formModal.formUpdateServer.isFormOpen = true;
      }

      if (type === this.formModal.formUpdateProxy.type) {
        this.formModal.formUpdateProxy.values.proxy =
          this.copyrightInfo.proxyServer;
        this.formModal.formUpdateProxy.isFormOpen = true;
      }

      if (type === this.formModal.formUpdatePeriod.type) {
        this.formModal.formUpdatePeriod.values.interval =
          this.copyrightInfo.interval;

        this.formModal.formUpdatePeriod.values.unit = this.copyrightInfo.unit;
        this.formModal.formUpdatePeriod.isFormOpen = true;
      }
    },
  },

  mounted() {
    this.getCopyright();

    for (let i = 5; i <= 180; i++) {
      this.listIntervalMinutes.push(i);
    }

    for (let i = 1; i <= 24; i++) {
      this.listIntervalHours.push(i);
    }
  },
};
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}

.copyright-actions:hover {
  opacity: 0.5;
  cursor: pointer;
}

.edit {
  margin-left: 10px;
  &:hover {
    opacity: 0.5;
  }
}

.enabled {
  color: #2096f2;
}

.inactive {
  color: red;
}

.close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
}

/deep/ button.modal-close {
  display: none;
}
</style>
<style src="vue-select/dist/vue-select.css"></style>
